module.exports = __webpack_public_path__ + "img/about-map-2.ec6e77ee.png";